import {isEmpty,indexOf} from "underscore";
import { copy } from "angular";
import { User } from '../../../../model/user/user.model';
import { SecretQuestion } from '../../../../model/user/secretQuestion.model';
import { Constant } from '../../../../model/common/constant';
import { UserService } from "../../../../shared/services/user/user.service";
import { ForgotLoginPageState } from "../../forgotlogin.component";
import { WindowService, IWindowOption } from "../../../../shared/services/common/window/window.service";

let template = require('./secretquestions.html');

export class SecretQuestionsComponent implements ng.IComponentController {
    public user: User;
    public userjson: string;


    public userService: UserService;
    public windowService: WindowService;
    public $translate: ng.translate.ITranslateService;

    public pageStateLocal: number = 0;
    public pageState: number;
    public selectedSecretQuestion: SecretQuestion;


    public static $inject: Array<string> = ["$translate", "UserService", "WindowService"];
    constructor($translate: ng.translate.ITranslateService, userService: UserService, windowService: WindowService) {
        this.userService = userService;
        this.$translate = $translate;
        this.windowService = windowService;
    }
    $onInit() {
        this.pageStateLocal = ForgotLoginPageState.VerifySecurityQuestion;
    }

    continue() {
        if (this.selectedSecretQuestion && !isEmpty(this.selectedSecretQuestion.Answer)) {
            let selectSecretQuestionIndex = indexOf(this.user.SelectedSecretQuestions, this.selectedSecretQuestion);
            this.selectedSecretQuestion.IsSelected = true;
            
            let users = copy(this.user);
            users.SelectedSecretQuestions = [this.selectedSecretQuestion];

            this.userService.validateSecurityQuestions(users).then((res: ng.IHttpPromiseCallbackArg<boolean>) => {
                if (res.data) {
                    this.pageStateLocal = ForgotLoginPageState.ResetPassword;
                }
                else {
                    this.windowService.showErrorWindow({
                        TextContent: this.$translate.instant("TEXT.PASSWORD.INCORRECTANSWERS")
                    } as IWindowOption);
                }
            });
        }
        else {
            this.windowService.showErrorWindow({
                TextContent: this.$translate.instant("TEXT.PASSWORD.SECURITYQUESTIONS")
            } as IWindowOption);
        }
    }


    back() {
        this.pageState = ForgotLoginPageState.ForgotLogin;
    }
}

export let secretQuestionsComponent: ng.IComponentOptions = {
    template: template.default,
    transclude: false,
    controllerAs: Constant.CtrlAs,
    controller: SecretQuestionsComponent,
    bindings: {
        user: Constant.Binding.ONEWAY,
        pageState: Constant.Binding.TWOWAY

    }
};

